var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{ref:"ico",attrs:{"viewBox":"0 0 100 100"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('use',{attrs:{"xlink:href":_vm.src + '#' + _vm.name}})])
}
var staticRenderFns = []

export { render, staticRenderFns }